<template>
    <div class="structure-box">
        <HeaderNav
            header-title="按结构"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="structure-box-content">
            <!-- 图表1 -->
            <div id="main"></div>
            <div class="zhanwei"></div>
            <!-- 图表2 -->
            <div class="chartsPosition">
                <div id="mainOne"></div>
                <span>单位(万方)</span>
            </div>
            <div class="zhanwei"></div>
            <!-- 图表3 -->
            <div id="mainTwo"></div>
        </div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Dialog } from 'vant';
export default {
    data() {
        return {
            selectTimeYear: '',
            selectTimeMonth: '',
            orgId: '',
            // 图表数据
            getSalesStructData: {},
            chartName: [], // X轴名称
            chartSales: [], // 销量
            chartPrice: [], // 售价
            chartGrossRate: [], // 毛利率
            chartCost: [], // 成本
            chartSaleRate: [], // 销售占比
            chartSaleRateStr: [], // 销售占比Str
            originChart: [],
            // 中低标
            diArr: [],
            gaoArr: [],
            zhongArr: [],
            parentArr: [],
            idCodeList: [],
            chartInData: [],
        };
    },
    mounted() {
        localStorage.setItem('objTimeYear', this.$route.query.year);
        localStorage.setItem('objTimeMonth', this.$route.query.month);
        this.selectTimeYear = this.$route.query.year;
        this.selectTimeMonth = this.$route.query.month;
        const value = this.$store.state.orgData[0].value;
        this.orgId = value;
        this.getSalesInfo();
        this.getlistRecursion();
    },
    components: {
        HeaderNav,
    },
    methods: {
        // 拉取递归
        getlistRecursion() {
            this.diArr = [];
            this.gaoArr = [];
            this.zhongArr = [];
            this.parentArr = [];
            this.idCodeList = [];
            this.$axios
                .get('/interfaceApi/baseinfo/businessgroup_config/getlist_recursion?parent_code=F9-01')
                .then(res => {
                    let gradeOne = 0;
                    let gradeTwo = 0;
                    let gradeThree = 0;
                    const newArr = [];
                    res.forEach(item => {
                        if (item.parent_code === 'F9-01') {
                            this.parentArr.push(item.name);
                            this.idCodeList.push(item.code);
                        }
                        if (this.idCodeList[0] === item.parent_code) {
                            this.diArr.push(item.name);
                        } else if (this.idCodeList[1] === item.parent_code) {
                            this.gaoArr.push(item.name);
                        } else if (this.idCodeList[2] === item.parent_code) {
                            this.zhongArr.push(item.name);
                        }
                    });
                    setTimeout(() => {
                        this.getSalesStructData.forEach(item => {
                            this.diArr.forEach(items => {
                                if (item.name === items) {
                                    gradeOne = (gradeOne * 10000 + (item.sales || 0) * 10000) / 10000;
                                }
                            });
                            this.zhongArr.forEach(items => {
                                if (item.name === items) {
                                    gradeThree = (gradeThree * 10000 + (item.sales || 0) * 10000) / 10000;
                                }
                            });
                            this.gaoArr.forEach(items => {
                                if (item.name === items) {
                                    gradeTwo = (gradeTwo * 10000 + (item.sales || 0) * 10000) / 10000;
                                }

                            });
                        });
                        newArr.push(gradeOne.toFixed(2), gradeTwo.toFixed(2), gradeThree.toFixed(2));
                        let obj = {
                            value: 0,
                            name: '',
                        };
                        this.parentArr.forEach((item, index) => {
                            obj = {
                                name: item,
                                value: newArr[index],
                                backgroundColoe: 'red',
                            };
                            this.chartInData.push(obj);
                        });
                    }, 100);
                    Promise.all([this.chartInData]).then(() => {
                        setTimeout(() => {
                            this.drawPieChart();
                        }, 500);
                    }).catch(() => {
                    });
                })
                .catch(() => {
                });
        },
        toFixedFunction(item) {
            if (item) {
                return item.toFixed(2);
            }
            return 0;
        },
        // 图表信息
        getSalesInfo() {
            this.chartName = [];
            this.chartSales = [];
            this.chartPrice = [];
            this.chartGrossRate = [];
            this.chartCost = [];
            this.chartSaleRate = [];
            this.chartSaleRateStr = [];
            this.$axios
                .get(`/interfaceApi/report/SaleManager/get_sales_struct/${this.selectTimeYear}/${this.selectTimeMonth}/${this.orgId}`)
                // .get(`/interfaceApi/report/SaleManager/get_sales_struct/2019/3/${this.orgId}`)
                .then(res => {
                    if (res) {
                        this.getSalesStructData = res;
                        res.forEach(item => {
                            if (item.name !== '其他') {
                                let obj = {};
                                // 售价
                                let arr;
                                if (item.sales) {
                                    arr = item.sales.toFixed(2);
                                } else {
                                    arr = 0;
                                }
                                // 销量
                                let brr;
                                if (item.gross_rate) {
                                    brr = item.gross_rate.toFixed(2);
                                } else {
                                    brr = 0;
                                }
                                const chengben = this.toFixedFunction(item.cost);
                                const jiage = this.toFixedFunction(item.price);
                                this.chartName.push(item.name);
                                this.chartSales.push(arr);
                                this.chartPrice.push(jiage);
                                this.chartGrossRate.push(brr);
                                this.chartCost.push(chengben);
                                this.chartSaleRate.push(item.sale_rate);
                                this.chartSaleRateStr.push(item.chartSaleRateStr);
                                const aNumber = Number(item.sales).toFixed(2);
                                if (aNumber > 0) {
                                    obj = {
                                        value: aNumber,
                                        name: item.name,
                                    };
                                    this.originChart.push(obj);
                                }
                            }
                        });
                        setTimeout(() => {
                            this.drawChart();
                            this.threeTable();
                        }, 700);
                    }
                })
                .catch(error => {
                    Dialog({ message: error.Errorcode.Message });
                });
        },
        // 图表1
        drawChart() {
            const myChart = this.$echarts.init(document.getElementById('main'));
            // 指定图表的配置项和数据
            const option = {
                title: {
                    x: 'left',
                    text: '本月商砼量价分析',
                    paddingBottom: 20,
                },
                tooltip: {
                    trigger: 'axis',
                    // backgroundColor: '#EAEFFC'
                },
                legend: {
                    padding: 35,
                    data: ['销量', '售价'],
                    itemWidth: 20, // 图例图形宽度
                    itemHeight: 10,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.chartName,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        boundaryGap: true,
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '销量(万方)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '售价(元/方)',
                        axisLabel: {
                            fontSize: 10, // 字体大小
                            formatter: '{value}',
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        data: this.chartSales,
                        color: '#5588F1',
                        barWidth: 10, // 柱图宽度
                    },
                    {
                        name: '售价',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.chartPrice,
                        color: '#FA8436',
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
        drawPieChart() {
            // 基于准备好的dom，初始化echarts实例
            const myCharts = this.$echarts.init(document.getElementById('mainOne'));
            const option = {
                title: {
                    x: 'left',
                    text: '本月商砼销项结构分析',
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)',
                },
                series: [
                    {
                        name: ' ',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: [0, '30%'],
                        center: ['50%', '60%'],
                        color: ['#4ba7e7', '#f3b43f', '#5bc370'],
                        label: {
                            position: 'inner',
                            fontSize: 10,
                            formatter: '{hr|}{b|{b} }\n{per|{d}%}',
                            rich: {
                            },
                        },
                        labelLine: {
                            show: false,
                        },
                        itemStyle: {
                            borderWidth: 5,
                            borderColor: '#FFFFFF',
                        },
                        data: this.chartInData,
                    },
                    {
                        name: ' ',
                        type: 'pie',
                        center: ['50%', '60%'],
                        radius: ['40%', '55%'],
                        label: {
                            formatter: '{hr|}{b|{b} }{per|{d}%}',
                            rich: {
                            },
                        },
                        // eslint-disable-next-line max-len
                        color: [ '#2d80a0', '#3799bc', '#59b5da', '#79d1f5', '#ffb204', '#026d43', '#00875c', '#13a277', '#3ec090', '#5eddaa', '#66fcbf' ],
                        itemStyle: {
                            borderWidth: 5,
                            borderColor: '#FFFFFF',
                        },
                        data: this.originChart,
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myCharts.setOption(option, true);
        },
        // 图表3
        threeTable() {
            // 基于准备好的dom，初始化echarts实例
            const myChart = this.$echarts.init(document.getElementById('mainTwo'));
            // 指定图表的配置项和数据
            const option = {
                title: {
                    x: 'left',
                    text: '本月商砼售价成本分析',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                legend: {
                    padding: 35,
                    data: ['售价', '成本', '毛利率'],
                    itemWidth: 20, // 图例图形宽度
                    itemHeight: 10,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.chartName,
                        axisPointer: {
                            type: 'shadow',
                        },
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(元/方)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '毛利率(%)',
                        axisLabel: {
                            formatter: '{value}',
                            fontSize: 10, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '售价',
                        type: 'bar',
                        data: this.chartPrice,
                        color: '#5588F1',
                        barWidth: 5, // 柱图宽度
                    },
                    {
                        name: '成本',
                        type: 'bar',
                        data: this.chartCost,
                        color: '#FA8436',
                        barWidth: 5, // 柱图宽度
                    },
                    {
                        name: '毛利率',
                        type: 'line',
                        yAxisIndex: 1,
                        data: this.chartGrossRate,
                        color: '#C64FDF',
                    },
                ],
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option, true);
        },
    },
};
</script>

<style lang="stylus" scoped>
div
    overflow-y scroll
#wapper
    overflow-y scroll
.structure-box-content
    height 100%
    overflow-y scroll
    padding-top 44rpx
.zhanwei
    width 100%
    height 15rpx
    background #F0F0F0
#main
    width 90%
    height 300rpx
    margin 15rpx 5% 0
#mainOne
    width 90%
    height 300rpx
    margin 0 5%
    margin 15rpx 5% 0
#mainTwo
    width 90%
    height 300rpx
    margin 0 5%
    margin 15rpx 5% 0
.chartsPosition
    position relative
    span
        position absolute
        font-size: 12rpx;
        font-weight:400;
        color: rgba(151,158,167,1);
        z-index 10
        top 24rpx
        right 40rpx
</style>